// src/components/StudyNoteCard.js
import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function StudyNoteCard({ note }) {
  return (
    <Card className="h-100 shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Badge bg="secondary">{note.category}</Badge>
          <small className="text-muted">{note.date}</small>
        </div>
        
        <Card.Title className="h5">{note.title}</Card.Title>
        
        <Card.Text className="text-muted">
          {note.content.substring(0, 150)}...
        </Card.Text>
        
        <div className="mb-3">
          {note.tags.map(tag => (
            <Badge key={tag} bg="light" text="dark" className="me-1">
              #{tag}
            </Badge>
          ))}
        </div>
      </Card.Body>
      
      <Card.Footer className="bg-transparent">
        <div className="d-flex justify-content-between">
          <Button 
            as={Link} 
            to={`/study-notes/${note.id}`}
            variant="outline-primary" 
            size="sm"
          >
            Read More
          </Button>
          <div>
            {note.youtubeUrl && (
              <Badge bg="danger" className="me-1">
                <i className="bi bi-youtube"></i> Video
              </Badge>
            )}
            {note.podcastUrl && (
              <Badge bg="info">
                <i className="bi bi-mic"></i> Podcast
              </Badge>
            )}
          </div>
        </div>
      </Card.Footer>
    </Card>
  );
}

export default StudyNoteCard;